import get from 'lodash/get';
import getSettingsFromThemedProps from '@splunk/themes/getSettingsFromThemedProps';

const chartingThemes = {
    light: {
        enterprise: 'default',
        prisma: 'default',
    },
    dark: {
        enterprise: 'dark',
        prisma: 'prismaDark',
    },
};

/*
 * convert theme name for splunk-charting based visualization
 * @params {Object} theme
 * @return {String} 'prismaDark', 'dark' or 'default'
 */
export const getChartingThemeKey = theme => {
    if (!theme) {
        return 'prismaDark';
    }

    const { colorScheme, family } = getSettingsFromThemedProps({ theme });
    return get(chartingThemes, [colorScheme, family], 'prismaDark');
};
